import React from 'react';

import useStyles from './ProcessFooter.style';

const ProcessFooter: React.FC = ({ children }) => {
  const c = useStyles({});

  return (
    <footer className={c.root}>
      {children}
    </footer>
  );
};

export { ProcessFooter };
